<script setup>
import ModuleInvoicingTable from '@frontJs/components/tables/projectManagement/modules/tenantReports/ModuleInvoicingTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Facturation modules - Modules - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle> Gestion de projet - Modules - Facturation modules </PageTitle>

    <TabLayout
        :tabs="{
            emailingAutomation: {
                title: 'Emailing automatisé',
                content: h(ModuleInvoicingTable, {
                    type: 'emailing_automation',
                }),
            },
            emailing: {
                title: 'Emailing',
                content: h(ModuleInvoicingTable, {
                    type: 'emailing',
                }),
            },
            customerTicket: {
                title: 'Ticket client',
                content: h(ModuleInvoicingTable, {
                    type: 'customer_ticket',
                }),
            },
        }"
    />
</template>
